module.exports = __webpack_public_path__ + "assets/img/settle_header_a.f7aeda49.png";